module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/battle-payments.83ba812b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/battle-payments.png
// module id = 3712
// module chunks = 11